import request from "@/utils/request";
import storage from "store";
import {TENANT} from "@/store/mutation-types";

const api = {
  getImChatList: "/im/chat",
  pageChatMessage: "/im/chat/message",
  createEmptyChat: "/im/chat/create",
  getUnreadTotal: "/im/chat/unread/total",
  readChatMessage: "/im/chat/read"
};

export function getImChatList(parameter) {
  return request({
    url: api.getImChatList,
    method: "get",
    params: parameter,
  });
}


export function pageChatMessage(parameter) {
  return request({
    url: api.pageChatMessage,
    method: "get",
    params: parameter,
  });
}

export function createEmptyChat(parameter) {
  return request({
    url: api.createEmptyChat,
    method: "post",
    data: parameter,
  });
}

export function getUnreadTotal(parameter) {
  return request({
    url: api.getUnreadTotal,
    method: "get",
    params: parameter,
  });
}

export function readChatMessage(parameter) {
  return request({
    url: api.readChatMessage,
    method: "post",
    params: parameter,
  });
}
